import { MoreVert } from '@mui/icons-material'
import ToggleOffOutlinedIcon from '@mui/icons-material/ToggleOffOutlined'
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined'
import { IconButton, Menu } from '@mui/material'

import { ListItemButton } from 'components/List'
import { useMenu } from 'hooks/useMenu'
import { HeaderMenuProps } from './types'

export const ProductsHeaderMenu = ({
  i18nResource: t,
  productState: { disabledToggle, onToggle },
}: HeaderMenuProps): React.JSX.Element => {
  const { anchor, close, isOpen, open } = useMenu()

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    event.stopPropagation()
    open(event)
  }

  const handleActivate = (): void => {
    onToggle(true)
    close()
  }

  const handleDeactivate = (): void => {
    onToggle(false)
    close()
  }

  const Activate = (): React.JSX.Element => (
    <ListItemButton
      disabled={disabledToggle}
      icon={<ToggleOnOutlinedIcon data-cy='toggle-on-outlined-icon' />}
      onClick={handleActivate}
      text={t('list.headerMenu.productToggle.activate')}
    />
  )

  const Deactivate = (): React.JSX.Element => (
    <ListItemButton
      disabled={disabledToggle}
      icon={<ToggleOffOutlinedIcon data-cy='toggle-off-outlined-icon' />}
      onClick={handleDeactivate}
      text={t('list.headerMenu.productToggle.deactivate')}
    />
  )

  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVert data-cy='more-vert-icon' />
      </IconButton>

      <Menu
        anchorEl={anchor}
        onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void =>
          event.stopPropagation()
        }
        onClose={close}
        open={isOpen}
      >
        <Activate />
        <Deactivate />
      </Menu>
    </>
  )
}
